/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import Swal from "sweetalert2";
import ReactStars from "react-rating-stars-component";
import { axiosInstanceWithToken } from "../helpers/axios";

const ReplyReview = ({
    replyModal,
    setReplyModal,
    selectedId,
    selectedRowStatus,
}) => {
    const [popupOpen, setPopupOpen] = useState(true);
    const [reply, setReply] = useState(true);
    const modalBodyRef = useRef(null);

    const schema = yup.object().shape({
        reason: yup.string().max(500, "Reason cannot exceed 500 characters").required("Reason is required"),
        reply: yup.string().max(500, "Reply cannot exceed 500 characters"),
    });

    const {
        register,
        handleSubmit: onSubmit,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    });

    const {
        id,
        meta_data,
    } = selectedId?.original;

    const parseMetaData = JSON.parse(meta_data);

    useEffect(() => {
        Swal.fire({
            icon: "info",
            text:
                (parseMetaData?.reply === "No Reply" || parseMetaData?.replies?.reply === "No Reply")
                    ? "You have already chosen to not reply, and this was a final action."
                    : "You can only reply to a review one time.",
            showConfirmButton: true,
        }).then(() => {
            setPopupOpen(false);
        });
        if (replyModal && modalBodyRef.current) {
            modalBodyRef.current.scrollTop = modalBodyRef.current.scrollHeight;
        }
    }, []);

    const handleUpdateReview = async (data) => {
        let formData = new FormData();
        formData.append('meta_data', JSON.stringify({
            ...parseMetaData,
            replies: {
                reply: data?.reply || 'No Reply',
                reason: data?.reason || 'No Reason',
            }
        }));
        formData.append('reply', data?.reply || 'No Reply');
        formData.append('_method', 'PATCH');

        try {
            await axiosInstanceWithToken.post(`/review/${id}`, formData).then((response) => {
                if (response?.data?.status) {
                    Swal.fire({
                        icon: "success",
                        title: "You have successfully replied to the review",
                        showConfirmButton: false,
                        timer: 1500,
                    }).then(() => {
                        setReplyModal(false);
                    });
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "Failed to reply!",
                        showConfirmButton: false,
                        timer: 1500,
                    });
                }
                setPopupOpen(false);
            });
        } catch (error) {
            console.error(error?.respomse?.data?.message);
        }
    }

    const submitReply = (data) => {
        handleUpdateReview(data);

    };

    const handleNoReply = (event) => {
        handleUpdateReview({
            reason: 'No Reply',
            reply: 'No Reply',
        })

    };




    return (
        <div className={`fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50`}>
            <div className="bg-white rounded-lg shadow-lg w-11/12 md:w-3/5 lg:w-2/5">
                <div className="border-b px-4 py-2 flex justify-between items-center">
                    <h3 className="text-xl font-semibold">Reply to your review</h3>
                    <button
                        onClick={() => setReplyModal(false)}
                        className="text-gray-600 hover:text-gray-900 focus:outline-none"
                    >
                        ✕
                    </button>
                </div>
                <div ref={modalBodyRef} className="px-4 py-2 max-h-96 overflow-y-auto">
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                        {[
                            { label: "Overall Satisfaction", value: parseMetaData?.ratings?.Overall_Satisfaction },
                            { label: "Cleanliness", value: parseMetaData?.ratings?.Cleanliness },
                            { label: "Accuracy", value: parseMetaData?.ratings?.Accuracy },
                            { label: "Communication", value: parseMetaData?.ratings?.Communication },
                            { label: "Location", value: parseMetaData?.ratings?.Location },
                            { label: "Check-in", value: parseMetaData?.ratings?.Check_in },
                            { label: "Value", value: parseMetaData?.ratings?.Value },
                        ].map((item, idx) => (
                            <div key={idx} className="flex flex-col items-start">
                                <label className="font-medium">{item.label}</label>
                                <ReactStars count={5} value={item.value || 0} size={30} activeColor="#ffd700" edit={false} />
                            </div>
                        ))}
                    </div>

                    <form onSubmit={onSubmit(submitReply)} className="space-y-4 mt-6">
                        <div>
                            <label className="block text-sm font-medium mb-1">Write Your Reason:</label>
                            <textarea
                                {...register("reason")}
                                defaultValue={parseMetaData?.replies?.reason || ''}
                                className="w-full p-2 border border-gray-300 rounded focus:ring focus:ring-blue-500 focus:outline-none"
                                rows="3"
                            />
                            <p className="text-red-500 text-sm mt-1">{errors.reason?.message}</p>
                        </div>

                        {reply && selectedRowStatus !== "No Reply" && (
                            <div>
                                <label className="block text-sm font-medium mb-1">Write Your Reply:</label>
                                <textarea
                                    {...register("reply")}
                                    defaultValue={parseMetaData?.replies?.reply || ''}
                                    className="w-full p-2 border border-gray-300 rounded focus:ring focus:ring-blue-500 focus:outline-none"
                                    rows="3"
                                />
                                <p className="text-red-500 text-sm mt-1">{errors.reply?.message}</p>
                            </div>
                        )}

                        <p className="text-sm italic text-gray-500">
                            Caution: Clicking "No Reply" is a final action; you will not be able to leave a review once it has been clicked.
                        </p>

                        <div className="flex justify-end gap-2">
                            {selectedRowStatus !== "No Reply" && (
                                <>
                                    {/* <button
                                        type="button"
                                        onClick={() => setReply(!reply)}
                                        className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                                    >
                                        Toggle Reply
                                    </button> */}
                                    <button
                                        type="button"
                                        onClick={handleNoReply}
                                        className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
                                    >
                                        No Reply
                                    </button>
                                </>
                            )}
                            {reply && selectedRowStatus !== "No Reply" && (
                                <button type="submit" className="bg-[#8ec639] text-white px-4 py-2 rounded hover:bg-green-600">
                                    Submit
                                </button>
                            )}
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ReplyReview;
